(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('hamburger-toggle')
    .addEventListener('click', () => {
      document.getElementById('mobile-drawer-menu').classList.toggle('open');
    });
});

  } catch(e) { console.error(e); }
})();
})();
